import { User } from '@dispatch/shared/types';

export const userWithResource: User = {
  id: 'id',
  tenantId: 'tenantId',
  externalId: 'externalId',
  resourceId: 'resourceId',
  roleId: 'roleId',
  firstName: 'firstName',
  lastName: 'lastName',
  disabledPermissions: [],
  deactivatedAt: new Date(),
  createdAt: new Date(),
  updatedAt: new Date(),
};

export const userWithoutResource: User = {
  id: 'id',
  tenantId: 'tenantId',
  externalId: 'externalId',
  resourceId: '',
  roleId: 'roleId',
  firstName: 'firstName',
  lastName: 'lastName',
  disabledPermissions: [],
  deactivatedAt: new Date(),
  createdAt: new Date(),
  updatedAt: new Date(),
};
